"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isArray = _interopRequireDefault(require("../object/isArray"));

var isEmpty = function isEmpty(array) {
  return !(0, _isArray["default"])(array) || !array.length;
};

var _default = isEmpty;
exports["default"] = _default;